import {
  StyledBody,
  StyledContainer,
  StyledHalf,
  StyledTitle,
  StyledWrapper,
} from "components/general/stylingHero";
import styled from "styled-components";

const StyledItem = styled.div`
  background-color: var(--raised-background-color);
  border: 1px solid var(--background-color);
  border-radius: 5px;
  margin: 1rem;
  flex: 1 1 50%;
  position: relative;
  padding: 2rem 2rem 3rem 2rem;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0;
  }
  svg,
  img {
    height: 2rem;
    width: 2rem;
    fill: #50d6cd;
  }
`;
const StyledSvgWrapper = styled.div`
  height: 3rem;
  width: 3rem;
  position: relative;
  border-radius: 3rem;
  background: var(--raised-background-color);
  border: 1px solid var(--background-color);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: 2rem;
  margin-bottom: 1rem;
  svg,
  img {
    fill: #50d6cd;
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const SvgOne = () => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 0C8.958 0 0 8.95 0 20c0 11.042 8.958 20 20 20 11.05 0 20-8.958 20-20C40 8.95 31.05 0 20 0zm0 36.667c-9.19 0-16.667-7.478-16.667-16.667 0-9.19 7.478-16.667 16.667-16.667 9.19 0 16.667 7.478 16.667 16.667 0 9.19-7.478 16.667-16.667 16.667z"
      fill="#DEDEDE"
    />
    <path
      d="M19.88 5.715c-7.805 0-14.166 6.36-14.166 14.166 0 7.82 6.36 14.167 14.167 14.167 7.82 0 14.166-6.347 14.166-14.167 0-7.805-6.346-14.166-14.166-14.166zm-.833 13.108c.242.142.534.225.834.225.291 0 .566.034.833.109a3.341 3.341 0 012.5 3.224 3.326 3.326 0 01-2.5 3.226v.941a.83.83 0 01-.833.834.83.83 0 01-.834-.834v-.941a3.336 3.336 0 01-2.5-3.226c0-.458.375-.833.834-.833.458 0 .833.375.833.834 0 .616.333 1.158.833 1.441.242.142.534.225.834.225.308 0 .591-.075.833-.216.5-.292.833-.826.833-1.45a1.63 1.63 0 00-.833-1.434 1.567 1.567 0 00-.833-.233c-.292 0-.567-.034-.834-.108a3.336 3.336 0 01-2.5-3.226 3.35 3.35 0 012.5-3.225v-.941c0-.458.375-.833.834-.833.458 0 .833.375.833.833v.941a3.341 3.341 0 012.5 3.225.83.83 0 01-.833.834.83.83 0 01-.834-.834 1.63 1.63 0 00-.833-1.433 1.567 1.567 0 00-.833-.233c-.3 0-.592.083-.834.233a1.64 1.64 0 00-.833 1.433c0 .617.333 1.159.833 1.442z"
      fill="#6C8EF8"
    />
  </svg>
);

const SvgTwo = () => (
  <svg width={46} height={40} viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.143 17.143a8.572 8.572 0 100-17.143 8.572 8.572 0 000 17.143zm0 5.714A17.143 17.143 0 0134.286 40H0a17.143 17.143 0 0117.143-17.143z"
      fill="#DEDEDE"
    />
    <path
      d="M39.165 7.302c.536.536.837 1.262.837 2.02v2.857h2.857a2.857 2.857 0 010 5.714h-2.857v2.858a2.857 2.857 0 01-5.715 0v-2.858H31.43a2.857 2.857 0 110-5.714h2.858V9.322a2.857 2.857 0 014.877-2.02z"
      fill="#6C8EF8"
    />
  </svg>
);

const Hero = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHalf tabletFlex="2">
          <StyledTitle>What is it all about?</StyledTitle>
          <StyledBody>
            At Redact, we believe in the power of community and sharing success. When you spread the
            word about us, whether through a friendly chat or a post on social media, it
            doesn&apos;t just help us grow – it rewards you too!
            <br />
            <br />
            Through our affiliate program, we&apos;re thrilled to offer you a share of the earnings
            as a thank-you for your valuable efforts.
          </StyledBody>
        </StyledHalf>
        <StyledHalf>
          <StyledItem>
            <StyledSvgWrapper>
              <SvgOne />
            </StyledSvgWrapper>
            <div>
              <h3>Commissions</h3>
              <div>
                Earn a share from each sale you refer, with no limits! We distribute your earnings
                monthly.
              </div>
            </div>
          </StyledItem>
          <StyledItem>
            <StyledSvgWrapper>
              <SvgTwo />
            </StyledSvgWrapper>
            <div>
              <h3>Dedicated support team</h3>
              <div>
                Our friendly support team is on standby, ready to assist you with any inquiries,
                anytime.
              </div>
            </div>
          </StyledItem>
        </StyledHalf>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
